<template>
    <div class="service-detail">
        <div class="module-item-style">
            <div class="module-item-title">评价详情</div>
            <div class="module-item-tips">查看用户对客服的评价</div>

            <div>
                <el-table
                        v-loading="isLoading"
                        stripe
                        :data="tableData"
                        :header-cell-style="{background:'#f2f2f2'}"
                        style="width: 100%;border: 1px solid #ebeef5;margin-top: 20px;">
                    <el-table-column
                            width="230"
                            show-overflow-tooltip
                            label="访客">
                        <template slot-scope="scope">
                            <div class="visitorInfo">
                                <div><img class="table-image table-image-avatar " :src="avatarX(scope.row.headImg)"
                                          alt="头像"></div>
                                <div class="visitorName"> {{scope.row.name}}</div>
                            </div>


                        </template>
                    </el-table-column>
                    <el-table-column
                            width="140"
                            prop="phone"
                            label="访客手机号">
                    </el-table-column>
                    <el-table-column
                            width="160"
                            prop="evaluateTime"
                            label="评价时间">
                    </el-table-column>
                    <el-table-column
                            width="140"
                            label="满意度">
                        <template slot-scope="scope">
                            <el-rate disabled
                                     v-model="+scope.row.evaluateGrade">
                            </el-rate>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="evaluateContent"
                            label="评价内容">
                    </el-table-column>
                </el-table>
                <pagenations
                        :total="total"
                        :size="pageSize"
                        @pageHandler="pageOperate">
                </pagenations>
            </div>
        </div>

    </div>
</template>

<script>
    import pagenations from '@/components/pagenations/pagenations'
    import avatar0 from '@/assets/images/client_avatar_empty.png'
    import avatar1 from '@/assets/images/client_avatar1.png'
    import avatar2 from '@/assets/images/client_avatar2.png'
    import avatar3 from '@/assets/images/client_avatar3.png'
    import avatar4 from '@/assets/images/client_avatar4.png'
    import avatar5 from '@/assets/images/client_avatar5.png'
    import avatar6 from '@/assets/images/client_avatar6.png'
    import avatar7 from '@/assets/images/client_avatar7.png'
    export default {
        name: "service-detail",
        components: {
            pagenations
        },
        data() {
            return {
                tableData: [],
                total: 0,
                currentPage: 1,
                pageSize: 10,
                isLoading:false,
            }
        },
        created() {
            this.getCsInfoRecord()
        },
        mounted() {

        },
        methods: {
            /**
             *  分页操作
             * @param val
             */
            pageOperate(val) {
                if (val.type == 'currentChange') {
                    this.currentPage = val.val
                } else if (val.type == "sizeChange") {
                    this.pageSize = val.val
                }
                this.getCsInfoRecord()
            },
            /**
             * 显示访客头像
             * 截取头像名称中的数字
             */
            avatarX(avatar) {
                if(avatar){
                    const img = avatar.substring(avatar.length - 5, avatar.length - 4)
                    switch (img) {
                        case 'y':
                            return avatar0
                            break
                        case '1':
                            return avatar1
                            break
                        case '2':
                            return avatar2
                            break
                        case '3':
                            return avatar3
                            break
                        case '4':
                            return avatar4
                            break
                        case '5':
                            return avatar5
                            break
                        case '6':
                            return avatar6
                            break
                        case '7':
                            return avatar7
                            break
                        default:
                            return avatar
                            break
                    }
                }else {
                    return avatar0
                }

            },
            getCsInfoRecord() {
                let postData = {
                    id:this.$route.query.id,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                this.isLoading = true
                this.$http.IndexCsInfoAPI(postData).then(res => {
                    if (res.status == 1) {
                        this.tableData = res.data.list
                        this.total = res.data.total
                    }
                    this.isLoading = false
                }).catch( err => {
                    this.isLoading = false
                })
            }
        },
    }
</script>

<style lang="scss">
    .service-detail {
        .table-image-avatar{
            display: block;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;

        }
        .visitorInfo{
            display: flex;
            align-items: center;
            .visitorName{
                width: 150px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
</style>